import BillsList from './BillsList';

export default BillsList;


// WEBPACK FOOTER //
// ./resources/assets/js/components/BillsList/index.js